import axios from "../configs/axios.config";

const SERVER = import.meta.env.VITE_API_URL;

// helper
const getAuthHeaders = () => {
  const token = localStorage.getItem("prima_session");

  if (!token) {
    throw new Error("Token not found");
  }

  return {
    Authorization: `Bearer ${token.replace(/^Bearer\s+/i, "").replace(/['"]/g, "")}`,
  };
};

// ---------------- CREATE ADMIN USER ----------------
const createNewUser = async (payload) => {
  try {
    const isFormData = payload instanceof FormData;

    const response = await axios.post(
      `${SERVER}/admin/new`,
      payload,
      {
        headers: {
          ...getAuthHeaders(),
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
        },
        withCredentials: true,
      }
    );

    return response.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create admin user",
    );
  }
};

// ---------------- GET ALL ADMINS ----------------
const fetchAllAdminUsers = async (page = 1, filters = {}, pageSize) => {
  try {
    const response = await axios.get(`${SERVER}/admin/list`, {
      headers: getAuthHeaders(),
      params: { page, limit: pageSize, ...filters },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch admin list",
    );
  }
};

// ---------------- DELETE ADMIN ----------------
const deleteAdminUser = async (id) => {
  try {
    const response = await axios.delete(`${SERVER}/admin/${id}`, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete user");
  }
};

// ---------------- GET ADMIN BY ID ----------------
const fetchUserDetailsById = async (id) => {
  try {
    const response = await axios.get(`${SERVER}/admin/${id}`, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch user details",
    );
  }
};

// ---------------- UPDATE ADMIN ----------------
const updateUserDetailsById = async (id, payload) => {
  try {
    const response = await axios.patch(`${SERVER}/admin/${id}`, payload, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update user");
  }
};

// ---------------- SUSPEND ADMIN ----------------
const suspendAdminById = async (id) => {
  try {
    const response = await axios.patch(
      `${SERVER}/admin/suspend/${id}`,
      {},
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to suspend/unsuspend user",
    );
  }
};

// -------- super admin can reset password of other admin ---------
const resetAdminPassword = async (id, payload) => {
  try {
    const response = await axios.patch(
      `${SERVER}/admin/reset-password/${id}`,
      payload,
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to reset password",
    );
  }
};

// --------- admin can change own password ----------
const changeOwnPassword = async (payload) => {
  try {
    const response = await axios.patch(
      `${SERVER}/admin/change-password`,
      payload,
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to change password",
    );
  }
};

export {
  createNewUser,
  fetchAllAdminUsers,
  deleteAdminUser,
  fetchUserDetailsById,
  updateUserDetailsById,
  suspendAdminById,
  resetAdminPassword,
  changeOwnPassword,
};
